module.exports = __webpack_public_path__ + "img/05.47e6c3d2.jpg";